export default __webpack_public_path__ + "static/media/Desktop.96272059.svg";